import * as constants from '../constants/actions';
import * as api from '../constants/api';
import * as endpoint from '../constants/endpoints';

import {parseJSON,isOk,authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function authSave(token, admin, role, tokenExpiry, uid) {
  return {
    type: constants.AUTH_SAVE,
    token,
    tokenExpiry,
    admin,
    role, 
    uid
  };
}

// Exists outside auth reducer in root reducer
export function authClear() {
	return {
		type: constants.AUTH_CLEAR
	}
}


export function authToggleHide() {
  return {
    type: constants.AUTH_HIDE_DATA,
  };
}

export function authSetSecondAuth() {
  return {
    type: constants.AUTH_SET_SECOND,
  }
}

/******************************
*******  Asynchronous  ********
******************************/

export async function fetchAppCredentials(email, signal) {
  return async (dispatch, getState) => {

    let url = api.API_URL + endpoint.USERS_DD_AUTH + '?key=88mcWPze588Iu9ZQr0epOLIT&email=' + encodeURIComponent(email);
    return fetch(url, {
      method: 'get',
      headers: authReq(api.HEADERS),
      signal,
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function checkLocalAuth(signal = null) {
  return async (dispatch, getState) => {

    let url = api.API_URL + endpoint.USERS_LOCAL_AUTH;
    return fetch(url, {
      method: 'get',
      headers: authReq(api.HEADERS),
      signal,
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}